import { render, staticRenderFns } from "./CameraMenu.vue?vue&type=template&id=7056324e&scoped=true"
import script from "./CameraMenu.vue?vue&type=script&lang=js"
export * from "./CameraMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7056324e",
  null
  
)

export default component.exports